import React from "react";
import DepartementPage from "./DepartementPage";

const AMOHautsDeSeine92 = () => {
  return <DepartementPage dept="hauts-de-seine" />;
};

export default AMOHautsDeSeine92;
